export default __webpack_public_path__ + "static/media/arrow_drop_up_white_24dp.3438eff9.svg";